<p-galleria
  [autoPlay]="autoPlay()"
  [circular]="circular()"
  [containerStyle]="containerStyle()"
  [numVisible]="numVisible()"
  [responsiveOptions]="responsiveOptions()"
  [showIndicatorsOnItem]="showIndicatorsOnItem()"
  [showIndicators]="showIndicators()"
  [showItemNavigators]="showItemNavigators()"
  [showThumbnails]="showThumbnails()"
  [value]="images()"
>
  <ng-template #item let-item>
    @if (getSrc(item)) {
      <img [ngSrc]="getSrc(item)" [alt]="item.alt || ''" width="1140" height="619.71" [priority]="true"/>
    }
  </ng-template>
</p-galleria>
